module.exports = __webpack_public_path__ + "img/yishenhe.0efdec05.jpg";